import { Host, h } from "@stencil/core";
let id = 0;
export class CoreCheckbox {
    constructor() {
        this.checkboxId = `checkbox-${++id}`;
        this.handleCheck = () => {
            if (this.disabled)
                return;
            this.checked = !this.checked;
            if (this.checked)
                this.indeterminate = false;
            this.coreCheckboxChange.emit({ value: this.value, checked: this.checked });
        };
        this.handleKeyDown = (event) => {
            if (this.disabled)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                this.handleCheck();
            }
        };
        this.renderLabel = () => {
            return (h("label", { class: "checkbox-label typography-body-medium-regular", id: `${this.checkboxId}-label`, onClick: this.handleCheck }, this.label));
        };
        this.renderDescription = () => {
            return h("span", { class: "checkbox-description typography-body-small-regular" }, this.description);
        };
        this.renderInfos = () => {
            return (h("div", { class: "infos-box" }, this.renderLabel(), this.description && this.renderDescription()));
        };
        this.label = undefined;
        this.value = undefined;
        this.description = undefined;
        this.format = 'right';
        this.checked = false;
        this.indeterminate = false;
        this.disabled = false;
    }
    render() {
        return (h(Host, { key: '3ad1e7a0c2574380007b51dd96801bc82b0fc4ce' }, h("div", { key: '4a1b3e9fbea02addaab40b8f0d322627e9a96f3b', class: `core-checkbox ${this.disabled ? 'checkbox--disabled' : ''} ${this.checked ? 'checkbox--checked' : ''} ${this.indeterminate ? 'checkbox--indeterminate' : ''}` }, this.format === 'left' && this.renderInfos(), h("div", { key: '13c6514bfc13527987f9057cb53df7489b761cd1', class: "checkbox-wrapper" }, h("span", { key: '4449c95efec926e9348315a4a92f1b408daba91c', role: "checkbox", class: "checkbox-box", tabindex: this.disabled ? -1 : 0, onKeyDown: this.handleKeyDown, onClick: this.handleCheck, "aria-label": this.format === 'hidden' ? this.label : null, "aria-labelledby": `${this.checkboxId}-label`, "aria-checked": this.indeterminate ? 'mixed' : `${this.checked}`, "aria-disabled": this.disabled }, this.indeterminate && !this.checked && (h("svg", { width: "1rem", height: "1rem", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 8C3 7.44772 3.44772 7 4 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H4C3.44772 9 3 8.55228 3 8Z" }))), this.checked && !this.indeterminate && (h("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.2313 3.84178C12.6872 4.15365 12.8038 4.77597 12.492 5.23177L8.15864 11.5651C7.98545 11.8182 7.70568 11.9779 7.39966 11.9982C7.09364 12.0186 6.7952 11.8974 6.59003 11.6694L3.59003 8.33605C3.22058 7.92554 3.25385 7.29325 3.66436 6.92379C4.07487 6.55433 4.70716 6.58761 5.07662 6.99812L7.22602 9.38635L10.8414 4.1024C11.1532 3.6466 11.7755 3.52991 12.2313 3.84178Z" }))))), this.format === 'right' && this.renderInfos())));
    }
    static get is() { return "core-checkbox"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-checkbox.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-checkbox.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label that accompany the checkbox. It is **required** for accessibility concerns."
                },
                "attribute": "label",
                "reflect": true
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The immutable value sent in the payload as identifier. It is **required**."
                },
                "attribute": "value",
                "reflect": true
            },
            "description": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description will append below the label."
                },
                "attribute": "description",
                "reflect": false
            },
            "format": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "'right' | 'left' | 'hidden'",
                    "resolved": "\"hidden\" | \"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A string indicating the position of the label or if it is hidden."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "'right'"
            },
            "checked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A Boolean indicating whether the box is checked or unchecked.\n\nIt should be false if the checkbox is `indeterminate`."
                },
                "attribute": "checked",
                "reflect": true,
                "defaultValue": "false"
            },
            "indeterminate": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A Boolean indicating whether the box is indeterminate or not.\n\nIt should be false if the checkbox is `checked`."
                },
                "attribute": "indeterminate",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A boolean indicating the disable state of the checkbox. The `aria-disabled` attribute relies on this property."
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "coreCheckboxChange",
                "name": "coreCheckboxChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the checked value has changed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=core-checkbox.js.map
